//home.js 用于获取首页json数据

import req from './http.js'  //引入封装好的axios

//在这里定义了一个登陆的接口，把登陆的接口暴露出去给组件使用
//这里使用了箭头函数，转换一下写法：
export const GETDATA1 =params=>req('get','cms/article/list/?catid=81&pageNum=1&pageSize=4'+'&orderColumn=sort desc,publish_time desc',params)
export const GETDATA2 =params=>req('get','cms/article/list/?catid=82&pageNum=1&pageSize=4'+'&orderColumn=sort desc,publish_time desc',params)
export const GETDATA3 =params=>req('get','cms/article/list/?catid=83&pageNum=1&pageSize=4'+'&orderColumn=sort desc,publish_time desc',params)

export const GETDATA4 =params=>req('get','cms/article/list/?catid=322&pageNum=1&pageSize=4'+'&orderColumn=sort desc,publish_time desc',params)
export const GETDATA5 =params=>req('get','cms/article/list/?catid=325&pageNum=1&pageSize=4'+'&orderColumn=sort desc,publish_time desc',params)
export const GETDATA6 =params=>req('get','cms/article/list/?catid=328&pageNum=1&pageSize=4'+'&orderColumn=sort desc,publish_time desc',params)

export const GETDATA7 =params=>req('get','cms/article/list/?catid=323&pageNum=1&pageSize=4'+'&orderColumn=sort desc,publish_time desc',params)
export const GETDATA8 =params=>req('get','cms/article/list/?catid=326&pageNum=1&pageSize=4'+'&orderColumn=sort desc,publish_time desc',params)
export const GETDATA9 =params=>req('get','cms/article/list/?catid=329&pageNum=1&pageSize=4'+'&orderColumn=sort desc,publish_time desc',params)
